import React from "react";
import { Spinner } from "reactstrap";

/**
 * Unified loading spinner component for the entire admin UI.
 *
 * @param {object} props
 * @param {"sm"|"lg"} [props.size="lg"]
 * @param {string} [props.color="primary"]
 * @param {string} [props.tip]
 * @param {string} [props.height="200px"]
 * @param {boolean} [props.inline=false]
 * @param {string} [props.className=""]
 */
const LoadingSpinner = ({
  size = "lg",
  color = "primary",
  tip,
  height = "200px",
  inline = false,
  className = "",
}) => {
  if (inline) {
    return (
      <span className={`d-inline-flex align-items-center ${className}`}>
        <Spinner size="sm" color={color} />
        {tip && (
          <span className="text-muted ms-2" style={{ fontSize: "13px" }}>
            {tip}
          </span>
        )}
      </span>
    );
  }

  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      style={{ height }}
    >
      <Spinner
        color={color}
        style={size === "lg" ? { width: "2rem", height: "2rem" } : undefined}
        size={size === "sm" ? "sm" : undefined}
      />
      {tip && (
        <p className="text-muted mt-2 mb-0" style={{ fontSize: "13px" }}>
          {tip}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
